import { studentMessagesEN } from './lib/intl/en-US';

export const programId = '5ef23322240cd31aa5f0db1a';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    marketConsent: {
        enabled: true,
        required: false,
    },
    messagesWithLocale: {
        'en-US': studentMessagesEN,
    },
};
